
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';
import { useSEO, generateContactPageSchema, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function ContactPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Contact Brushour | Painters & Decorators Watford Hertfordshire',
    description: 'Contact Brushour painters and decorators in Watford, Hertfordshire. Call 07595037441 or email daniel@brushour.co.uk for free quotes on painting and decorating services across Hertfordshire.',
    keywords: 'contact painters Watford, painting quotes Hertfordshire, decorators contact Watford, Brushour contact, free painting quote Hertfordshire',
    canonical: `${SITE_URL}/contact`,
    schema: [
      generateContactPageSchema(),
      generateWebPageSchema('Contact Brushour – Painters & Decorators Watford', 'Get in touch for free quotes on painting and decorating services in Watford and Hertfordshire', `${SITE_URL}/contact`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Contact', url: `${SITE_URL}/contact` },
      ]),
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <ContactMap />
      <Footer />
    </div>
  );
}
